import { render, staticRenderFns } from "./skumapping-look.vue?vue&type=template&id=a963fcb8"
import script from "./skumapping-look.vue?vue&type=script&lang=ts"
export * from "./skumapping-look.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports